import React from 'react';

import './styles.css';

const PrefixedInputBox = ({prefix, _onChange, id, name, value, maxLength}) => {
  return (
    <div className="gdocs-prefixed-input-box-container">
    <input type="text"
            className="gdocs-prefixed-input-prefix-box"
            value={prefix}
            disabled="true" />
    <input type="text"
            className="gdocs-prefixed-input-input-box"
            id={id}
            name={name}
            value={value || ''}
            maxLength={maxLength}
            onChange={_onChange} />
    </div>
  )
}

export default PrefixedInputBox;



// WEBPACK FOOTER //
// ./src/components/common/PrefixedInputBox/index.js